import { render, staticRenderFns } from "./Annuity.vue?vue&type=template&id=77b341d6&scoped=true"
import script from "./Annuity.vue?vue&type=script&lang=js"
export * from "./Annuity.vue?vue&type=script&lang=js"
import style0 from "./Annuity.vue?vue&type=style&index=0&id=77b341d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b341d6",
  null
  
)

export default component.exports